import { render, staticRenderFns } from "./ModalConfirmation.vue?vue&type=template&id=5c35c15d&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ModalConfirmation.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmation.vue?vue&type=style&index=0&id=5c35c15d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c35c15d",
  null
  
)

export default component.exports